let onLeaveCallbacks = [];
let current;

export default {
  set history(history) {
    history.listen(onLeave);
  },

  get current() {
    return current;
  },

  addWillLeaveListener(callback) {
    if (onLeaveCallbacks.indexOf(callback) === -1) {
      onLeaveCallbacks.push(callback);
    }
  },

  removeWillLeaveListener(callback) {
    let i = onLeaveCallbacks.indexOf(callback);
    if (i > -1) {
      onLeaveCallbacks.splice(i, 1);
    }
  },
};

function onLeave(location) {
  var url = location.pathname;
  if (url) {
    ga('send', 'pageview', url);
  } else {
    ga('send', 'pageview');
  }

  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }

  current = location.pathname;
  for (var c = 0; c < onLeaveCallbacks.length; c++) {
    if (onLeaveCallbacks[c]) {
      onLeaveCallbacks[c](location);
    }
  }
}



// WEBPACK FOOTER //
// ./client/stores/route.es6